import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import { useParams } from "react-router-dom";
import { secondAxios } from "../../../../../api/axios";
import DocReviewer from "./DocReviewer";
import DocumentTransmittalTab from "./DocumentTransmittalTab";
import { useDCS } from "./Table/DCSContext";
import PlantTasksWrapper from "../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
import ProjectTasksPage from "../../../Project/allProjectsPage/ProjectsTable/ProjectTasksPage";
import PageHeader from "../../../../../components/PageHeader";
import ModuleIconBadge from "../../../../../components/ModuleIconBadge";

const DCSTab = ({ plant = false }) => {
  const { projectId, plantId, id } = useParams();
  const activeProjectId = projectId || id;
  const { documentList } = useDCS();
  const [plantName, setPlantName] = useState("");
  const [projectName, setProjectName] = useState("");

  useEffect(() => {
    if (!plant || !plantId) {
      setPlantName("");
      return;
    }
    secondAxios
      .get(`/plant/${plantId}`)
      .then((res) => setPlantName(res.data?.name || ""))
      .catch(() => setPlantName(""));
  }, [plant, plantId]);

  useEffect(() => {
    if (plant) {
      setProjectName("");
      return;
    }
    if (!activeProjectId) {
      setProjectName("");
      return;
    }
    secondAxios
      .get(`/project/${activeProjectId}`)
      .then((res) =>
        setProjectName(
          res.data?.name || res.data?.projectName || res.data?.title || "",
        ),
      )
      .catch(() => setProjectName(""));
  }, [plant, activeProjectId]);

  console.log("plant in dcs is :", plant);
  console.log("document list in dcs is :", documentList);

  // console.log({ projectId });
  const tabs = [
    // {
    //   label: "MRQ",
    //   panel: <DCSTable projectId={projectId || ""} type="MRQ" />,
    // },
    {
      label: "Doc. Reviewer",
      moduleKey: "dcs-doc-reviewer",
      panel: <DocReviewer projectId={activeProjectId} plant={plant} />,
    },
    {
      label: "4D Schedule",
      moduleKey: "schedule",
      panel: plant ? (
        <PlantTasksWrapper type={"engineering"} />
      ) : (
        <ProjectTasksPage catList={documentList} plant={plant} />
      ),
    },
    {
      label: "Doc. Transmittal",
      moduleKey: "doc-transmittal",
      panel: <DocumentTransmittalTab />,
    },
    // {
    //   label: "RFI",
    //   panel: <DCSTable type="RFI" />,
    // },
    // {
    //   label: "Change Order",
    //   panel: <ChangeOrder type="Change Order" />,
    // },
    // {
    //   label: "Transmittal",
    //   panel: <DocumentTransmittalTab />,
    // },
  ];

  return (
    <Box>
      {plant ? (
        <PageHeader
          plant={{ id: plantId, name: plantName }}
          pageTitle="EMS (Engineering Management System)"
          moduleKey="dcs"
        />
      ) : (
        activeProjectId && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "space-between",
              px: 2,
              pt: 2,
              pb: 0,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <ModuleIconBadge moduleKey="dcs" size="md" />
              <Typography variant="h3" component="h1">
                EMS (Engineering Management System)
              </Typography>
            </Box>
            {projectName && (
              <Typography
                variant="h6"
                color="primary.main"
                fontWeight={600}
                sx={{ ml: "auto", lineHeight: 1.3 }}
              >
                {projectName}
              </Typography>
            )}
          </Box>
        )
      )}
      <NavTabs tabs={tabs} navLabel="dcs-tab" />
    </Box>
  );
};

export default DCSTab;
